export class UserAccess {
  userAccess: UserAccessEnum 
}

export enum UserAccessEnum {
  FREEMIUM,
  PREMIUM,
  INSIDER,
  CORPORATE
}